export default __webpack_public_path__ + "static/media/notification-a.8dad1421.svg";